import script from "./pending-vendors.vue?vue&type=script&setup=true&lang=js"
export * from "./pending-vendors.vue?vue&type=script&setup=true&lang=js"

import "./pending-vendors.vue?vue&type=style&index=0&id=2df8f76b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df8f76b"]])

export default __exports__